import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import WelcomeBanner from '../components/WelcomeBanner';
import './RaceLandingPage.css';

const RaceLandingPage = () => {
  const history = useHistory();

  const handleRoute = (route) => {
    switch (route) {
      case 'details':
        history.push('/race/details');
        break;
      case 'participants':
        history.push('/race/participants');
        break;
      case 'registration':
        history.push('/race/signup');
        break;
      case 'self-service':
        history.push('/race/select-login');
        break;
      default:
        break;
    }
  };

  return (
    <div className="race-landing-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              <div className="hero-content">
                <h1 className="hero-title">
                  2026 International Federation Convention Race</h1> 
                  <h2>Hosted By Central Jersey Combine</h2> 
                
                <p className="hero-subtitle">
                  Join pigeon racing enthusiasts from around the nation in the premier convention race event
                </p>
                <div className="hero-stats">
                  <div className="stat-item">
                    <span className="stat-number">300+</span>
                    <span className="stat-label">Miles</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">20,000 POINTS</span>
                    <span className="stat-label">FIRST PRIZE (Based on entries)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Logged In User Welcome Banner */}
      <WelcomeBanner />

      {/* Navigation Cards Section */}
      <div className="navigation-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="section-header text-center mb-5">
                <h2>What would you like to do?</h2>
                <p className="text-muted">Choose your path to get started with the 2026 Convention Race</p>
              </div>
              
              <div className="row g-4">
                {/* Registration Card - First Priority */}
                <div className="col-lg-3 col-md-6">
                  <div className="route-card featured" onClick={() => handleRoute('registration')}>
                    <div className="featured-badge">
                      <i className="bi bi-star-fill"></i>
                      <span>Get Started</span>
                    </div>
                    <div className="route-icon">
                      <i className="bi bi-person-plus-fill"></i>
                    </div>
                    <h3>Registration / Sign Up</h3>
                    <p>
                      Register as a handler or breeder for the 2026 Convention Race. 
                      Complete your profile and join this race event.
                    </p>
                    <div className="route-features">
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Handler Registration</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Breeder Sign Up</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Profile Management</span>
                      </div>
                    </div>
                    <div className="route-action primary">
                      <span>Sign Up Now</span>
                      <i className="bi bi-arrow-right"></i>
                    </div>
                  </div>
                </div>

                {/* Self-Service Card */}
                <div className="col-lg-3 col-md-6">
                  <div className="route-card" onClick={() => handleRoute('self-service')}>
                    <div className="route-icon">
                      <i className="bi bi-gear-fill"></i>
                    </div>
                    <h3>LOG IN to Self-Service Portal</h3>
                    <p>
                      Update your information, request and accept handler assignments, 
                      view birds assignment etc.
                    </p>
                    <div className="route-features">
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Login & Access Dashboard</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>View/Edit Your Profile</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>View/Edit Handler Requests</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>View/Edit Bird Information</span>
                      </div>
                    </div>
                    <div className="route-action">
                      <span>Access Portal</span>
                      <i className="bi bi-arrow-right"></i>
                    </div>
                  </div>
                </div>

                {/* Race Details Card */}
                <div className="col-lg-3 col-md-6">
                  <div className="route-card" onClick={() => handleRoute('details')}>
                    <div className="route-icon">
                      <i className="bi bi-info-circle-fill"></i>
                    </div>
                    <h3>View Race Details</h3>
                    <p>
                      Learn about race rules, schedule, release points, and important information
                      for the 2026 Convention Race.
                    </p>
                    <div className="route-features">
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Race Schedule & Rules</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Release Point Information</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Prize Information</span>
                      </div>
                    </div>
                    <div className="route-action">
                      <span>Learn More</span>
                      <i className="bi bi-arrow-right"></i>
                    </div>
                  </div>
                </div>

                {/* Participant List Card */}
                <div className="col-lg-3 col-md-6">
                  <div className="route-card" onClick={() => handleRoute('participants')}>
                    <div className="route-icon">
                      <i className="bi bi-people-fill"></i>
                    </div>
                    <h3>View Participants</h3>
                    <p>
                      Browse the complete list of registered participants, handlers, and breeders
                      participating in the race.
                    </p>
                    <div className="route-features">
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Handler Information</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Breeder Directory</span>
                      </div>
                      <div className="feature-item">
                        <i className="bi bi-check2"></i>
                        <span>Contact Information</span>
                      </div>
                    </div>
                    <div className="route-action">
                      <span>Browse Participants</span>
                      <i className="bi bi-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Important Dates Section */}
      <div className="py-5" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="text-center mb-5">
                <h2 className="fw-bold mb-3" style={{ color: '#0b3d91' }}>
                  <i className="bi bi-calendar-event me-3"></i>
                  Important Dates
                </h2>
                <p className="text-muted fs-5">Mark your calendar for these key milestones</p>
              </div>
              
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm hover-lift" style={{ transition: 'transform 0.2s ease' }}>
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="bi bi-calendar-plus-fill fs-1 text-dark"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Start accepting birds</h5>
                      <div className="display-6 fw-bold text-dark mb-2">March 15 2026</div>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm hover-lift" style={{ transition: 'transform 0.2s ease' }}>
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="bi bi-calendar-x-fill fs-1 text-dark"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Ends accepting birds</h5>
                      <div className="display-6 fw-bold text-dark mb-2">May 15, 2026</div>
                      <p className="text-muted mb-1">(Replacements until June 1)</p>
                      
                    </div>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm hover-lift" style={{ transition: 'transform 0.2s ease' }}>
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="bi bi-flag-fill fs-1 text-dark"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Race Day</h5>
                      <div className="display-6 fw-bold text-dark mb-2">Nov 7 2026</div>
                      <p className="text-muted mb-1">The big day!</p>
                      <small className="text-muted">(Weather permitting)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaceLandingPage;